const initialState = {
  resultsProductPricingList: [],
  resultsProductPricingCreate: [],
  resultsProductPricingUpdate: [],
  resultsProductPricingDelete: [],
  loading: false,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "GET_LIST_PRODUCT_PRICING":
    case "CREATE_PRODUCT_PRICING":
    case "UPDATE_PRODUCT_PRICING":
    case "DELETE_PRODUCT_PRICING":
      newState.loading = true;
      break;
    case "GET_LIST_PRODUCT_PRICING_RESPONSE":
      newState.resultsProductPricingList = action.value;
      newState.loading = false;
      break;
    case "CREATE_PRODUCT_PRICING_RESPONSE":
      newState.resultsProductPricingCreate = action.value;
      newState.loading = false;
      break;
    case "UPDATE_PRODUCT_PRICING_RESPONSE":
      newState.resultsProductPricingUpdate = action.value;
      newState.loading = false;
      break;
    case "DELETE_PRODUCT_PRICING_RESPONSE":
      newState.resultsProductPricingDelete = action.value;
      newState.loading = false;
      break;
    case "RESET_PRODUCT_PRICING_RESPONSES":
      newState.resultsProductPricingCreate = [];
      newState.resultsProductPricingUpdate = [];
      newState.resultsProductPricingDelete = [];
      break;
    case "RESET_PRODUCT_PRICING_LIST":
      newState.resultsProductPricingList = [];
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
